// import React from "react";
// import { useSearchParams } from "react-router-dom";

// const ResultEntryPdfHtml = () => {
//   const [searchParams] = useSearchParams();
//   const displayHeader = searchParams.get("display_header") === "true";

//   const htmlString = `<!DOCTYPE html>
//   <html lang="en">
//     <head>
//       <meta charset="utf-8" />
//       <link rel="icon" href="https://fe.aarggvtech.com/favicon.ico" />
//       <meta name="viewport" content="width=device-width, initial-scale=1" />
//       <meta name="theme-color" content="#000000" />
//       <meta name="description" content="Web site created using create-react-app" />
//       <link rel="apple-touch-icon" href="https://fe.aarggvtech.com/logo192.png" />
//       <link rel="manifest" href="https://fe.aarggvtech.com/manifest.json" />
//       <title>Lims</title>
//       <style>
//          html {
//            font-family: Helvetica, Segoe UI, sans-serif;
//            line-height: 1.5;
//            -ms-text-size-adjust: 100%;
//            -webkit-text-size-adjust: 100%;
//            -webkit-font-smoothing: antialiased;
//          }
//          body {
//            width: 100%;
//            font-family: sans-serif;
//            margin: 0;
//            font-size: 14px;
//            font-weight: 400;
//            line-height: 1.5;
//            color: #000000;
//            background: #ffffff;
//            -webkit-overflow-scrolling: touch;
//          }
//          body {
//            -webkit-print-color-adjust: exact;
//          }
//          img {
//            max-width: 100%;
//            border-style: none;
//          }
//          * {
//            -webkit-box-sizing: border-box;
//            -moz-box-sizing: border-box;
//            box-sizing: border-box;
//            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
//          }
//          *:focus {
//            outline: none;
//          }
//          .mainContainer {
//            display: table;
//            width: 1085px;
//            margin: 0 auto;
//            position: relative;
//          }
//          .mainContainer > .box {
//            display: table-cell;
//            width: 1085px;
//            height: auto;
//            justify-content: center;
//            text-align: center;
//          }
//          @media (max-width: 1024px) {
//            .mainContainer {
//              margin-left: 50px;
//              margin-right: 50px;
//              width: calc(100% - 100px);
//            }
//          }
//          @media (max-width: 768px) {
//            .mainContainer {
//              margin-left: 20px;
//              margin-right: 20px;
//              width: calc(100% - 40px);
//            }
//          }
//          @media (max-width: 480px) {
//            .mainContainer {
//              margin-left: 10px;
//              margin-right: 10px;
//              width: calc(100% - 20px);
//            }
//          }
//          @media print {
//            .mainContainer,
//            .mainContainer-sm {
//              max-width: 100%;
//            }
//            .mainSection .can-details-section {
//              border: 2px solid rgb(0, 0, 0) !important;
//            }
//          }
//          header {
//            display: table;
//            width: 100%;
//            padding: 18px 0;
//            position: relative;
//          }
//          .headerLeft,
//          .headerRight {
//            display: table-cell;
//            vertical-align: middle;
//            height: 75px;
//          }
//          .headerLeft {
//            width: 200px;
//            background: #57b0d8
//              url(https://labs.limslab.co/assets/pdfimg/blue-corner-bg.png)
//              no-repeat top right;
//            background-size: 53px 84px;
//          }
//          .headerRight {
//            width: 66%;
//            background: #57b0d8
//              url(https://fe.aarggvtech.com/assets/pdfimg/blue-line-bg.png)
//              no-repeat top left;
//            background-size: 121px 84px;
//          }
//          .logo {
//            width: 235px;
//            display: table-cell;
//            vertical-align: middle;
//            padding: 0 32px 0 15px;
//          }
//          .logo img {
//            width: 235px;
//            height: auto;
//            max-height: 70px;
//          }

//          .barcodeInfo {
//            display: table;
//            width: 100%;
//            margin: 16px 0;
//          }
//          .barcodeImage img {
//            width: 337px;
//            height: 100%;
//          }
//          .barcodeImage {
//            display: table-cell;
//            height: 55px;
//            margin-right: 70px;
//            text-align: right;
//          }
//          .mainSection {
//            display: table;
//            width: 100%;
//            padding: 0 0 0 29px;
//            position: relative !important;
//          }
//          .mainSection > .content {
//            display: table-row;
//          }
//          .mainSection::before {
//            content: "LIMS Speciality Laboratory";
//            font-size: 12px;
//            color: #757575;
//            line-height: 1.2;
//            position: absolute;
//            top: 150px;
//            left: -74px;
//            width: 190px;
//            -webkit-transform: rotate(-90deg);
//          }
//          footer {
//            width: 100%;
//            display: table;
//          }
//          footer > div {
//            display: table-row;
//          }
//          footer > div > * {
//            display: table-cell;
//            padding: 10px;
//          }
//          .footerBlueLine {
//            width: 100%;
//            height: 22px;
//            background: #58b0d8;
//            position: relative;
//          }
//          .footerBlueLine::before {
//            content: "";
//            position: absolute;
//            top: -76px;
//            right: 0;
//            border-top: 38px solid transparent;
//            border-left: 38px solid transparent;
//            border-bottom: 38px solid #58b0d8;
//            border-right: 38px solid #58b0d8;
//          }

//          .table-container {
//            position: relative;
//            width: 100%;
//            height: auto;
//          }

//          .table-container img {
//            position: absolute;
//            top: 0;
//            left: 0;
//            width: 100%;
//            height: 100%;
//            opacity: 0.1;
//            pointer-events: none;
//          }
//        </style>
//     </head>
//     <body>
//       <div>
//         <div class="mainContainer" id="content-id">
//           ${
//             displayHeader
//               ? `
//           <header>
//             <div class="headerLeft"></div>
//             <div class="logo">
//               <img
//                 src="https://fe.aarggvtech.com/assets/pdfimg/lims-logo.png"
//                 alt="Lims"
//               />
//             </div>
//             <div class="headerRight"></div>
//           </header>
//           <section class="barcodeInfo">
//             <div class="barcodeImage">
//               <img
//                 src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgsAAAEYCAIAAABdlyIxAAANHkl..."
//                 alt="Barcode"
//               />
//             </div>
//           </section>`
//               : ""
//           }
//         </div>
//       </div>
//     </body>
//   </html>`;

//   return (
//     <div>
//       <div dangerouslySetInnerHTML={{ __html: htmlString }}></div>
//     </div>
//   );
// };

// export default ResultEntryPdfHtml;


import React, { useEffect } from 'react';

const ResultEntryPdfHtml = () => {
  const openHtmlInNewTab = () => {
    const htmlContent = `
     <!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <link rel="icon" href="https://fe.aarggvtech.com/favicon.ico" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="theme-color" content="#000000" />
    <meta
      name="description"
      content="Web site created using create-react-app"
    />
    <link rel="apple-touch-icon" href="https://fe.aarggvtech.com/logo192.png" />
    <link rel="manifest" href="https://fe.aarggvtech.com/manifest.json" />
    <title>Lims</title>
    <style>
      html {
        font-family: Helvetica, Segoe UI, sans-serif;
        line-height: 1.5;
        -ms-text-size-adjust: 100%;
        -webkit-text-size-adjust: 100%;
        -webkit-font-smoothing: antialiased;
      }
      body {
        width: 100%;
        font-family: sans-serif;
        margin: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.5;
        color: #000000;
        background: #ffffff;
        -webkit-overflow-scrolling: touch;
      }
      body {
        -webkit-print-color-adjust: exact;
      }
      img {
        max-width: 100%;
        border-style: none;
      }
      * {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      }
      *:focus {
        outline: none;
      }
      .mainContainer {
        display: table;
        width: 1085px;
        margin: 0 auto;
        position: relative;
      }
      .mainContainer > .box {
        display: table-cell;
        width: 1085px;
        height: auto;
        justify-content: center;
        text-align: center;
      }
      @media (max-width: 1024px) {
        .mainContainer {
          margin-left: 50px;
          margin-right: 50px;
          width: calc(100% - 100px);
        }
      }
      @media (max-width: 768px) {
        .mainContainer {
          margin-left: 20px;
          margin-right: 20px;
          width: calc(100% - 40px);
        }
      }
      @media (max-width: 480px) {
        .mainContainer {
          margin-left: 10px;
          margin-right: 10px;
          width: calc(100% - 20px);
        }
      }
      @media print {
        .mainContainer,
        .mainContainer-sm {
          max-width: 100%;
        }
        .mainSection .can-details-section {
          border: 2px solid rgb(0, 0, 0) !important;
        }
      }
      header {
        display: table;
        width: 100%;
        padding: 18px 0;
        position: relative;
      }
      .headerLeft,
      .headerRight {
        display: table-cell;
        vertical-align: middle;
        height: 75px;
      }
      .headerLeft {
        width: 200px;
        background: #57b0d8
          url(https://labs.limslab.co/assets/pdfimg/blue-corner-bg.png)
          no-repeat top right;
        background-size: 53px 84px;
      }
      .headerRight {
        width: 66%;
        background: #57b0d8
          url(https://fe.aarggvtech.com/assets/pdfimg/blue-line-bg.png)
          no-repeat top left;
        background-size: 121px 84px;
      }
      .logo {
        width: 235px;
        display: table-cell;
        vertical-align: middle;
        padding: 0 32px 0 15px;
      }
      .logo img {
        width: 235px;
        height: auto;
        max-height: 70px;
      }

      .barcodeInfo {
        display: table;
        width: 100%;
        margin: 16px 0;
      }
      .barcodeImage img {
        width: 337px;
        height: 100%;
      }
      .barcodeImage {
        display: table-cell;
        height: 55px;
        margin-right: 70px;
        text-align: right;
      }
      .mainSection {
        display: table;
        width: 100%;
        padding: 0 0 0 29px;
        position: relative !important;
      }
      .mainSection > .content {
        display: table-row;
      }
      .mainSection::before {
        content: "LIMS Speciality Laboratory";
        font-size: 12px;
        color: #757575;
        line-height: 1.2;
        position: absolute;
        top: 150px;
        left: -74px;
        width: 190px;
        -webkit-transform: rotate(-90deg);
      }
      footer {
        width: 100%;
        display: table;
      }
      footer > div {
        display: table-row;
      }
      footer > div > * {
        display: table-cell;
        padding: 10px;
      }

      .footerBlueLine {
        width: 100%;
        height: 22px;
        background: #58b0d8;
        position: relative;
      }
      .footerBlueLine img {
        position: absolute;
        bottom: 10px;
        right: -10px;
      }
      /* .footerBlueLine::before {
        content: "";
        position: absolute;
        top: -76px;
        right: 0;
        border-top: 38px solid transparent;
        border-left: 38px solid transparent;
        border-bottom: 38px solid #58b0d8;
        border-right: 38px solid #58b0d8;
      } */

      .table-container {
        position: relative;
        width: 100%;
        height: auto;
      }

      .table-container img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.1;
        pointer-events: none;
      }
    </style>
  </head>
  <body>
    <div>
      <div class="mainContainer" id="content-id">
        <header>
          <div class="headerLeft"></div>
          <div class="logo">
            <img
              src="https://fe.aarggvtech.com/assets/pdfimg/lims-logo.png"
              alt="Lims"
            />
          </div>
          <div class="headerRight"></div>
        </header>
        <section class="barcodeInfo">
          <div class="barcodeImage">
            <img
              src="data:image/png;base64,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"
              width="{337}"
              height="{55}"
            />
          </div>
        </section>
        <main class="mainSection">
          <table
            width="100%"
            border="1"
            cellspacing="0"
            cellpadding="0"
            style="border-collapse: collapse"
          >
            <tr>
              <td colspan="2" style="padding: 20px">
                <table
                  width="100%"
                  border="0"
                  cellspacing="0"
                  cellpadding="0"
                  style="border-collapse: collapse"
                >
                  <tr>
                    <td>Name:</td>
                    <td>RAJASHREE SAHA</td>
                    <td>Registration No:</td>
                    <td>3</td>
                  </tr>
                  <tr>
                    <td>Age/Gender:</td>
                    <td>23 Y / Female</td>
                    <td>Registration Date:</td>
                    <td>2024-12-17 17:03</td>
                  </tr>
                  <tr>
                    <td>Patient ID:</td>
                    <td>3</td>
                    <td>Receiving Date:</td>
                    <td>10/01/2024</td>
                  </tr>
                  <tr>
                    <td>Barcode No:</td>
                    <td>100000000035</td>
                    <td>Reporting Date:</td>
                    <td>10/01/2024</td>
                  </tr>
                  <tr>
                    <td>Refer By:</td>
                    <td></td>
                    <td>Panel Code:</td>
                    <td>KUL</td>
                  </tr>
                  <tr>
                    <td>Laboratory Name:</td>
                    <td>LIMS</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

          <div class="table-container">
            <img
              src="https://labs.limslab.co/assets/img/logo.png"
              alt="Lims"
            />
            <table
              width="100%"
              border="0"
              cellspacing="0"
              cellpadding="5"
              style="border-collapse: collapse"
            >
              <tr>
                <td
                  colspan="4"
                  style="
                    text-align: center;
                    font-weight: bold;
                    padding: 10px;
                    text-decoration: underline;
                  "
                >
                  DEPARTMENT OF BIOCHEMISTRY
                </td>
              </tr>
              <tr style="border-bottom: 2px solid #afafaf !important">
                <th style="text-align: left; width: 25%">Test Name</th>
                <th style="text-align: left; width: 25%">Result</th>
                <th style="text-align: left; width: 25%">Unit</th>
                <th style="text-align: left; width: 25%">
                  Biological Ref.Interval
                </th>
              </tr>
              <tr>
                <td>
                  <u style="text-align: center; font-weight: bold"
                    >Glucose Fasting</u
                  ><br />Glucose Fasting
                </td>
                <td>148.0</td>
                <td>mg/dl</td>
                <td>
                  Normal: < 150<br />
                  Borderline: 150-199<br />
                  High: 200-499<br />
                  Very High: >500
                </td>
              </tr>
              <tr>
                <td>
                  <u style="text-align: center; font-weight: bold"
                    >Glucose Fasting</u
                  ><br />Glucose Fasting
                </td>
                <td>148.0</td>
                <td>mg/dl</td>
                <td>
                  Normal: < 150<br />
                  Borderline: 150-199<br />
                  High: 200-499<br />
                  Very High: >500
                </td>
              </tr>
              <tr>
                <td>
                  <u style="text-align: center; font-weight: bold"
                    >Glucose Fasting</u
                  ><br />Glucose Fasting
                </td>
                <td>148.0</td>
                <td>mg/dl</td>
                <td>
                  Normal: < 150<br />
                  Borderline: 150-199<br />
                  High: 200-499<br />
                  Very High: >500
                </td>
              </tr>
              <tr>
                <td>
                  <u style="text-align: center; font-weight: bold"
                    >Glucose Fasting</u
                  ><br />Glucose Fasting
                </td>
                <td>148.0</td>
                <td>mg/dl</td>
                <td>
                  Normal: < 150<br />
                  Borderline: 150-199<br />
                  High: 200-499<br />
                  Very High: >500
                </td>
              </tr>
              <tr>
                <td
                  style="
                    font-weight: bold;
                    font-family: Times New Roman, Times, serif;
                    font-size: 12px;
                    font-style: italic;
                  "
                >
                  Sample Type:
                  <span>Serum</span>
                </td>
              </tr>
              <tr>
                <td style="font-weight: bold; font-size: 12px">
                  Test has been performed on TB-120FR2
                </td>
              </tr>
            </table>
          </div>
          <table
            width="100%"
            border="0"
            cellspacing="0"
            cellpadding="10"
            style="border-collapse: collapse; border-top: 2px solid black"
          >
            <tr>
              <td
                colspan="2"
                style="text-align: center; font-weight: bold; padding: 20px"
              >
                *** End Of Report ***
              </td>
            </tr>
          </table>
          <table
            width="100%"
            border="0"
            cellspacing="0"
            cellpadding="0"
            style="border-collapse: collapse"
          >
            <tr>
              <td colspan="2">
                <p>
                  Quality Controlled by National Accreditation Board of testing
                  and calibration Laboratories.<br />
                  Sample Source: OSS.
                </p>
                <table width="100%" border="0" cellspacing="0" cellpadding="10">
                  <tr>
                    <td style="width: 25%; text-align: left; font-weight: bold">
                      <img
                        src="https://fe.aarggvtech.com/assets/pdfimg/lims-scan.png"
                        alt="QR Code"
                        style="width: 100px"
                      />
                    </td>
                    <td style="text-align: left; font-weight: bold">
                      Dr. Debashri Mondal<br />MD (Pathology)<br />Consultant
                      Pathologist
                    </td>
                    <td style="text-align: left; font-weight: bold">
                      Dr. D. Sen<br />MD (Biochemistry)<br />Consultant
                      Biochemist
                    </td>
                    <td style="text-align: left; font-weight: bold">
                      Dr. S. SAHA<br />MD (Pathology)<br />Consultant
                      Pathologist
                    </td>
                    <td style="text-align: left; font-weight: bold">
                      Dr. A. Saha<br />MD (Biochemistry)<br />Consultant
                      Biochemist<br />Reg. No: 36245
                    </td>
                  </tr>
                </table>
                <div>
                  <p
                    style="
                      font-weight: bold;
                      font-family: Times New Roman Times, serif;
                      font-size: 18px;
                    "
                  >
                    Approved Name: KANCHAN SIL
                  </p>
                  <span
                    style="
                      font-family: Times New Roman Times, serif;
                      font-size: 14px;
                    "
                  >
                    Print Date: 10/07/2024
                  </span>
                </div>
              </td>
            </tr>
          </table>
        </main>
        <footer>
          <div class="footerBlueLine">
            <img
              src="https://fe.aarggvtech.com/assets/pdfimg/triangle.png"
              alt="triangle"
            />
          </div>
        </footer>
      </div>
    </div>
  </body>
</html>
    `;

    const blob = new Blob([htmlContent], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  };

  useEffect(() => {

    openHtmlInNewTab();
  }, []);
};

export default ResultEntryPdfHtml;
